/**
 * Epoch-based color theming for progressive visual corruption.
 * Wave 1-12: Green dominant (Epoch I)
 * Wave 13-24: Green + Amber pollution (Epoch II)
 * Wave 25-35: Red dominant, grid corruption (Epoch III)
 */

import { RARITY } from "../core/palette.ts";
import { COLORS, EPOCH } from "./designTokens.ts";

export interface EpochColors {
  primary: string;
  accent: string;
  corruption: number;
}

export function getEpochColors(wave: number): EpochColors {
  if (wave <= 12) {
    return { ...EPOCH.I, corruption: 0 };
  }
  if (wave <= 24) {
    return {
      ...EPOCH.II,
      corruption: (wave - 12) / 12,
    };
  }
  return { ...EPOCH.III, corruption: 1 };
}

/** Operator identity accent — all five operators, central tokens only
 *  (architect/cipher follow their OPERATOR_RARITY tier hues, S126). The
 *  corruption reads this as the identity color ECHELON consumes. */
export function getOperatorAccent(operator: string): string {
  switch (operator) {
    case "warden":
      return COLORS.ICE_CYAN;
    case "ghost":
      return COLORS.AMBER_WARN;
    case "architect":
      return RARITY.legendary.mid;
    case "cipher":
      return RARITY.epic.mid;
    default:
      return COLORS.SENTINEL_GREEN;
  }
}
